import "../../../components/common/Tables/DataTable.css"
import React from "react";
import { useSelector } from "react-redux";
import RootState from "../../../redux/states/root.state";
import ApiKeyCell from "../../../components/common/ApiKeyCell";
import SpaLink from "../../../components/common/SpaLink";
import usePermissionCheck from "../../../hooks/usePermissionCheck";
import { DataTableFoot } from "../../../components/common/Tables/DataTableParts";

// Action is pinned to the right edge (px, fits Generate / Revoke)
const ACTION_WIDTH = 120;

interface TableProps {
  setGenerateOpen: any;
  setRevokeOpen: any;
  setSpaToModify: any;
  // Shown in the table's toolbar (the API docs note)
  toolbar?: React.ReactNode;
}

const MyApiKeysTable: React.FC<TableProps> = ({
  setGenerateOpen,
  setRevokeOpen,
  setSpaToModify,
  toolbar,
}) => {
  const { data: spas, loading } = useSelector((state: RootState) => state.myApiKeys);
  const { canAccess: isStaff } = usePermissionCheck(['view_spa_details']);

  const pinStyle = {'--dt-right': '0px', '--dt-w': `${ACTION_WIDTH}px`} as React.CSSProperties;

  return (
    <div className="dt">
      {toolbar && <div className="dt-toolbar">
        <div className="dt-toolbar-start">{toolbar}</div>
      </div>}

      <div className="dt-scroll">
        {loading ? (
          <div className="dt-state"><span className="spinner" role="progressbar" aria-label="Loading API keys"/></div>
        ) : spas.length > 0 ? (
          <table className="dt-table">
            <thead>
              <tr>
                <th scope="col">Nickname</th>
                <th scope="col">Serial</th>
                <th scope="col">Spa GUID</th>
                <th scope="col">API Key</th>
                <th scope="col" className="dt-center dt-pin dt-pin-start" style={pinStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {spas.map((spa: any, i: number) => (
                <tr key={spa?.spaGuid ?? i}>
                  <td className="dt-strong">{spa?.name ?? <span className="dt-na">—</span>}</td>
                  <td>
                    <SpaLink isStaff={isStaff} spaV2Id={spa?.spaV2Id} spaGuid={spa?.spaGuid} label={spa?.serial} className="dt-serial" />
                  </td>
                  <td>
                    <SpaLink isStaff={isStaff} spaV2Id={spa?.spaV2Id} spaGuid={spa?.spaGuid} label={spa?.spaGuid} className="dt-guid" />
                  </td>
                  <td><ApiKeyCell apiKey={spa?.apiKey} /></td>
                  <td className="dt-center dt-pin dt-pin-start" style={pinStyle}>
                    {spa?.hasActiveKey ? (
                      <button
                        type="button"
                        className="btn btn-sm dt-row-btn danger"
                        onClick={() => { setSpaToModify(spa); setRevokeOpen(true); }}
                      >
                        Revoke
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-sm btn-primary dt-row-btn"
                        onClick={() => { setSpaToModify(spa); setGenerateOpen(true); }}
                      >
                        Generate
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="dt-state"><div className="dt-empty-title">No Spas Found</div></div>
        )}
      </div>

      {/* One page: every spa you own is listed */}
      <DataTableFoot
        shown={spas?.length ?? 0}
        total={spas?.length ?? 0}
        noun={spas?.length === 1 ? 'Spa' : 'Spas'}
        page={1}
        totalPages={1}
        loading={loading}
        onPage={() => {}}
      />
    </div>
  );
};

export default MyApiKeysTable;
